import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import RouteErrorScreen from '@/components/RouteErrorScreen'
import type { AuthSearch } from '@/components/auth/AuthPage'

// Legacy route: /register permanently redirects to /signup, preserving any
// invite/redirect params. The actual page lives in components/auth/AuthPage.
export const Route = createFileRoute('/register')({
  validateSearch: (search: Record<string, unknown>): AuthSearch => ({
    invitationcode: typeof search.invitationcode === 'string' ? search.invitationcode : undefined,
    __clerk_ticket: typeof search.__clerk_ticket === 'string' ? search.__clerk_ticket : undefined,
    showSubModal: typeof search.showSubModal === 'string' ? search.showSubModal : undefined,
    redirectTo: typeof search.redirectTo === 'string' ? search.redirectTo : undefined,
  }),
  component: RegisterRedirect,
  errorComponent: RouteErrorScreen,
})

function RegisterRedirect() {
  const navigate = useNavigate()
  const search = Route.useSearch()

  useEffect(() => {
    navigate({
      to: '/signup',
      search,
      replace: true,
    })
  }, [navigate, search])

  return null
}
